"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedTypes = exports.highwayFont = exports.default = exports.RoadShield = void 0;
var React = _interopRequireWildcard(require("react"));
var _commonLib = require("@caps-mobile/common-lib");
var SC = _interopRequireWildcard(require("./Styled"));
var _interfaces = require("../interfaces");
var SHIELDS = _interopRequireWildcard(require("./resources"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// libraries

// styles

// types & models

// resources

// constants

var highwayFont = "Highway Gothic";
exports.highwayFont = highwayFont;
var supportedTypes = [_interfaces.EATRoadwayType.Interstate, _interfaces.EATRoadwayType.StateRoute, _interfaces.EATRoadwayType.USRoute];
exports.supportedTypes = supportedTypes;
var RoadShield = function RoadShield(props) {
  var text = props.text,
    textSize = props.textSize,
    textHeight = props.textHeight,
    type = props.type,
    _props$width = props.width,
    width = _props$width === void 0 ? _constants.SHIELD_WIDTHS[text.length] : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? _constants.iconLarge.height : _props$height;

  // check that the given type is currently supported in shields
  // if not, default to StateHighway
  var validatedType = (0, _commonLib.nuon)(type) && supportedTypes.includes(_interfaces.EATRoadwayType[type]) ? type : _interfaces.EATRoadwayType.Unknown;

  // shields with text longer than 2 digits utilize a narrower font family
  var fontType = text.length > 2 ? "Highway Gothic Narrow" : "Highway Gothic";
  var sourceList = SHIELDS[validatedType];
  var source = sourceList[text.length];
  return /*#__PURE__*/React.createElement(SC.StyledRoadShield, {
    width: width,
    height: height,
    iconType: type,
    text: text
  }, /*#__PURE__*/React.createElement(SC.StyledShieldImg, {
    width: width,
    height: height,
    src: source
  }), /*#__PURE__*/React.createElement(SC.StyledShieldText, {
    width: width,
    height: height,
    iconType: validatedType,
    fontType: fontType,
    textSize: textSize,
    textHeight: textHeight
  }, text));
};
exports.RoadShield = RoadShield;
var _default = RoadShield;
exports.default = _default;